function removeHyphensAndCapitalize(text: string) {
  if (!text.includes('-')) return text;
  return text.replace(/-./g, (match) => match.charAt(1).toUpperCase());
}

export { removeHyphensAndCapitalize };
